export const ContentType = Object.freeze({
	None: 0,
	Device: 1
});